module.exports = __webpack_public_path__ + "img/resized-cover3.ecdee6f1.png";